export default "__VITE_ASSET__f995c37c__"